<template>
  <div class="flex flex-col lg:flex-row w-full h-full mx-auto py-4 lg:p-6">
    <div class="bg-white shadow-lg rounded-lg w-12/12 lg:w-2/6 mx-4 py-4 overflow-hidden mb-4 lg:mb-0">
      
      <div class="h-full overflow-auto px-4">
      
        <div class="flex items-center gap-1 justify-end pb-4 sticky top-0 bg-white relative z-10">
          <h1 class="flex items-center font-bold text-gray-900 px-2 py-2 gap-1 leading-tight tracking-wider">
            Revisión de aportes
            <span class="rounded-full px-4 py-1 bg-gray-200">
              {{ filteredRaising.length }}
            </span>
          </h1>
          <div class="flex-1"></div>
          <button
            class="border p-1 rounded border-gray-700"
            @click="changeRaisingOrder"
            v-tooltip.right="'Ordena tus aportes de forma ascendente o descendente'"
            aria-label="Ordenar aportes ascentente o descendente"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"/>
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>
        </div>

        <input
          type="text"
          v-model="search"
          placeholder="Búsqueda de aportes"
          class="w-full appearance-none border rounded py-2 px-3 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white"
        />
      
        <div class="w-full">
          <div class="w-full relative">
            <select
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 mb-1 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              name="status"
              id="status"
              v-model="categoryFilter"
              @change="updateSelectRegister()"
            >
              <option selected value="-1">Todas</option>
              <option
                v-for="category in categories"
                :key="category.nombre_proyecto"
                :value="category.nombre_proyecto"
              >
                {{ category.nombre_proyecto }}
              </option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              aria-hidden="true"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilterRaising = 'TODOS'),
                filteredRaising,
                updateSelectRegister()
            "
            class="w-full hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilterRaising === 'TODOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            :colorT="color_terciario"
          >
            Todos {{ filteredRaisingByAll.length }}
          </btn-action>
        </div>
        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilterRaising = 'NO REVISADOS'),
                filteredRaising,
                updateSelectRegister()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilterRaising === 'NO REVISADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            v-tooltip="'Aportes que enviaste para la aprobación del revisor'"
            :colorT="color_terciario"
          >
            En revisión {{ filteredRaisingByOpen.length }}
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilterRaising = 'RECHAZADOS'),
                filteredRaising,
                updateSelectRegister()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilterRaising === 'RECHAZADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            :colorT="color_terciario"
          >
            Rechazadas {{ filteredRaisingByCanceled.length }}
          </btn-action>
        </div>
        <div class="w-full flex gap-1 my-1">
          <btn-action
            v-on:click="
              (statusFilterRaising = 'EN REVISIÓN'),
                filteredRaising,
                updateSelectRegister()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilterRaising === 'EN REVISIÓN'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            v-tooltip="
              'Aportes a las que el revisor hizo comentarios para que realices los cambios pertinentes y pueda ser aprobada'
            "
            :colorT="color_terciario"
          >
            En modificación {{ filteredRaisingByAssigned.length }}
          </btn-action>
          <btn-action
            v-on:click="
              (statusFilterRaising = 'APROBADOS'),
                filteredRaising,
                updateSelectRegister()
            "
            class="w-1/2 hover:text-white border rounded p-2 font-semibold"
            v-bind:class="[
              statusFilterRaising === 'APROBADOS'
                ? 'border-transparent bg-selected'
                : 'bg-transparent',
            ]"
            :colorT="color_terciario"
          >
            Aprobadas {{ filteredRaisingByAttended.length }}
          </btn-action>
        </div>


        <div-selected-styled
          v-for="one_raising in filteredRaising"
          :key="one_raising.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{
            'bg-selected': one_raising.id === currentRaising.id,
          }"
          @click="selectRaising(one_raising)"
          :colorT="color_terciario"
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="h-10 w-10 fill-current group-hover:text-gray-900 text-gray-100"
              viewBox="0 -960 960 960"
            >
              <path
                d="M280-280h280v-80H280v80Zm0-160h400v-80H280v80Zm0-160h400v-80H280v80Zm-80 480q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"
              />
            </svg>
          </div>
          <div class="flex flex-col flex-grow ml-2">
            <!-- <div class="w-1/2"> -->
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ one_raising.titulo }}</span
            >
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{
                one_raising.fecha_levantamiento | moment("DD/MM/YYYY hh:mm A")
              }}</span
            >
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-sm group-hover:text-gray-700"
              >F-{{ one_raising.id }}
              <span v-if="one_raising.status === 'EN REVISIÓN'"
                >EN MODIFICACIÓN</span
              >
              <span v-else>{{ one_raising.status }}</span>
            </span>
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-xs group-hover:text-gray-700"
              >{{ one_raising.nombre_proyecto }}</span
            >
            <!-- </div> -->
          </div>
          <div
            v-if="one_raising.en_pausa === true"
            class="flex self-start justify-self-end text-xs"
          >
            <div
              class="px-3 py-1 rounded-full border-2 border-blue-700 text-xs text-white bg-blue-500"
            >
              En pausa
            </div>
          </div>
        </div-selected-styled>
      </div>
    </div>
    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-12/12 lg:w-4/6 mx-4 py-8 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="w-full pb-2 text-right">
            <!--             <button
              v-if="downloadActive && currentRaising.status === 'APROBADO'"
              v-on:click="showingConfirmDownload = true"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Descargar Aportes
            </button>
            <button
              v-on:click="exportPDF()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Descargar Reporte
            </button> -->
            <!--             <button
              v-if="
                currentRaising.status === 'NO REVISADO' ||
                currentRaising.status === 'EN REVISIÓN'
              "
              v-on:click="newChatModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Mensajes
            </button> -->
            <!--             <button
              v-if="currentRaising.status !== 'APROBADO'"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="openEditModal()"
            >
              Editar
            </button> -->
            <!--             <button
              v-if="currentRaising.activo"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="showingDeactivationConfirm = true"
            >
              Desactivar
            </button>
            <button
              v-if="currentRaising.activo === false"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
              @click="showingActivationConfirm = true"
            >
              Activar
            </button> -->
            <btn-action
              v-if="currentRaising.geometria !== null"
              id="downGeojson"
              v-on:click="toGeojsonFile()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
              >Geojson</btn-action
            >

            <btn-action
              v-if="currentRaising.geometria !== null"
              id="downKML"
              v-on:click="toKMLFile()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
              >KML</btn-action
            >

            <btn-action
              v-if="currentRaising.geometria !== null"
              id="downSHP"
              v-on:click="toSHPFile()"
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
              :colorT="color_terciario"
              >Shapefile (zip)</btn-action
            >
            <btn-action
              v-if="
                (currentRaising.status === 'APROBADO' &&
                  email === currentRaising.email_curador) ||
                (currentRaising.status === 'APROBADO' &&
                  category === 'ADMINISTRADOR')
              "
              class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 border hover:border-transparent rounded"
              @click="showingDisaproveConfirm = true"
              :colorT="color_terciario"
            >
              Desaprobar
            </btn-action>

            <button
              v-if="category === 'ADMINISTRADOR'"
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingDeleteConfirm = true"
            >
              Eliminar
            </button>
          </div>

          <alert-dialog :showing="showingDisaproveConfirm">
            <div class="flex items-center justify-center">
              <div class="uppercase text-gray-900">
                ¿Realmente desea desaprobar esta ficha? Pasará de nuevo a
                revisión y ya no será visible en el mapa y buscador hasta que se
                apruebe de nuevo.
              </div>
            </div>
            <div class="w-full flex items-center justify-center">
              <button
                class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-orange-500 border-4 font-bold tracking-wider bg-white hover:bg-orange-300"
                @click="desaprobarFicha()"
              >
                Desaprobar
              </button>
              <button
                class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
                @click="showingDisaproveConfirm = false"
              >
                Cancelar
              </button>
            </div>
          </alert-dialog>

          <alert-dialog :showing="showingSuccessDisaprove">
            <div class="flex items-center justify-center">
              <div class="uppercase text-gray-900">
                Ficha desaprobada exitosamente
              </div>
              <div class="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
                  viewBox="0 0 24 24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                  />
                </svg>
              </div>
            </div>
            <div class="w-full">
              <button
                class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
                @click="showingSuccessDisaprove = false"
              >
                Cerrar
              </button>
            </div>
          </alert-dialog>

          <alert-dialog :showing="showingDeleteConfirm">
            <div class="flex items-center justify-center">
              <div class="uppercase text-gray-900">
                ¿Realmente desea ELIMINAR esta ficha? se eliminará por completo
                del sistema. Esta acción no se puede deshacer
              </div>
            </div>
            <div class="w-full flex items-center justify-center">
              <button
                class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
                @click="eliminarFicha()"
              >
                Eliminar
              </button>
              <button
                class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
                @click="showingDeleteConfirm = false"
              >
                Cancelar
              </button>
            </div>
          </alert-dialog>

          <alert-dialog :showing="showingSuccessDelete">
            <div class="flex items-center justify-center">
              <div class="uppercase text-gray-900">
                Ficha eliminada exitosamente
              </div>
              <div class="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
                  viewBox="0 0 24 24"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                  />
                </svg>
              </div>
            </div>
            <div class="w-full">
              <button
                class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
                @click="showingSuccessDelete = false"
              >
                Cerrar
              </button>
            </div>
          </alert-dialog>

          <div class="flex">
            <h1
              class="pb-1 text-left font-bold tracking-widest text-neutral-100"
            >
              {{ currentRaising.cat_principal }}
            </h1>
          </div>
          <div class="flex">
            <div class="h-80 w-full">
              <l-map
                ref="map"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="4"
                :center="center"
                :options="{ zoomControl: true }"
                @ready="onMapReady"
              >
                <!-- <l-geo-json :geojson="polygon" :options-style="geoStyle" /> -->
                <l-tile-layer
                  :url="urlBasemap"
                  :attribution="attribution"
                ></l-tile-layer>
                <l-marker :lat-lng="center" :visible="showMarker"></l-marker>
              </l-map>
            </div>
          </div>
          <div class="flex w-full">
            <div
              class="flex flex-col w-11/12 lg:w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
              <div class="flex items-center">
                <div class="flex items-center w-1/2 text-left text-xs">
                  <div
                    v-if="currentRaising.status === 'NO REVISADO'"
                    class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} EN REVISIÓN
                  </div>
                  <div
                    v-if="currentRaising.status === 'RECHAZADO'"
                    class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} {{ currentRaising.status }}
                  </div>
                  <div
                    v-if="currentRaising.status === 'EN REVISIÓN'"
                    class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} EN MODIFICACIÓN
                  </div>
                  <div
                    v-if="currentRaising.status === 'APROBADO'"
                    class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} {{ currentRaising.status }}
                  </div>
                  <!-- <svg
                    class="ml-4 cursor-pointer"
                    @click="showRaisingChatModal(currentRaising)"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    />
                  </svg> -->
                  <btn-action
                    v-if="currentRaising.id_proyecto != null"
                    v-on:click="showProjectDetailModal()"
                    class="bg-transparent font-semibold hover:text-white py-1 px-4 mx-1 mt-0 border hover:border-transparent rounded"
                    :colorT="color_terciario"
                  >
                    ver proyecto
                  </btn-action>
                </div>
                <div class="w-1/2 text-right text-xs text-gray-900">
                  {{
                    currentRaising.fecha_levantamiento
                      | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>
              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Título:</span>
                </div>
                <div
                  class="w-full lg:w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.title }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre del registrante:</span>
                </div>
                <div
                  class="w-full lg:w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.nombre }} {{ currentRaising.apellido }}
                </div>
              </div>

              <div
                class="flex flex-col lg:flex-row w-full text-xs pt-2 tracking-wide justify-center"
                v-if="currentRaising.id_curador !== null"
              >
                <div
                  class="w-full lg:w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span
                    class="font-bold"
                    v-if="currentRaising.status !== 'NO REVISADO'"
                    >Atendido por:</span
                  >
                </div>
                <div
                  class="w-full lg:w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.nombre_curador }}
                  {{ currentRaising.apellido_curador }}
                </div>
              </div>

              <div
                class="flex flex-wrap w-full items-center justify-center px-3 mb-6 md:mb-0"
              >
                <template v-if="list_path_media_folder !== []">
                  <div
                    v-for="(path_media_folder, mediaIndex) in list_path_media_folder"
                    class="flex w-1/2 items-center justify-center"
                    :key="mediaIndex"
                  >
                    <div
                      v-if="path_media_folder.mimeType == 'video/mp4'"
                      class="p-2"
                    >
                      <video
                        :src="replaceURL(path_media_folder.fileName, 'video')"
                        width="640"
                        height="480"
                        controls
                        controlslist="nodownload"
                      />
                    </div>
                    <div
                      v-if="
                        path_media_folder.mimeType == 'image/jpeg' ||
                        path_media_folder.mimeType == 'image/png'
                      "
                      class="p-2"
                      v-on:click="
                        openFullPictureModal(
                          replaceURL(path_media_folder.fileName, 'img')
                        )
                      "
                    >
                      <v-lazy-image
                        :src="replaceURL(path_media_folder.fileName, 'img')"
                        class="cursor-pointer"
                      />
                    </div>
                  </div>
                </template>
              </div>

              <div
                v-if="
                  currentRaising.isfromgallery !== null &&
                  currentRaising.isfromgallery == true
                "
              >
                <span style="color: red; font-size: small">
                  *Las imágenes provienen de la galería del usuario
                </span>
              </div>

              <div
                v-if="
                  currentRaising.insitu !== null &&
                  currentRaising.insitu == false
                "
              >
                <span style="color: red; font-size: small">
                  **El usuario señaló que no se encontraba en el sitio al
                  momento de llenar la ficha
                </span>
              </div>

              <p class="pb-1 pt-2 text-sm text-left font-bold tracking-widest">
                Ficha de información:
              </p>

              <div v-if="currentRaising.tiempos_encuesta" class="mb-4 text-left p-3 bg-blue-100 rounded text-sm text-blue-800">
                <p><strong>Tiempo Total de la Encuesta:</strong> {{ (currentRaising.tiempos_encuesta.total / 1000).toFixed(1) }} seg</p>
                <div v-if="Object.keys(currentRaising.tiempos_encuesta.secciones).length > 0">
                  <p class="font-bold mt-2">Tiempo por sección:</p>
                  <ul class="list-disc pl-5">
                    <li v-for="(time, section) in currentRaising.tiempos_encuesta.secciones" :key="section">
                      <strong>{{ section }}:</strong> {{ (time / 1000).toFixed(1) }} seg
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Ficha de información-->
              <div
                v-for="(one_question, index) in currentQuestions"
                :key="'q_' + index"
                :class="nestedStatusFicha[index] ? 'pl-6 border-l-4 border-gray-300 ml-2 mb-4' : 'mb-4'"
              >
                <div v-if="one_question.tipo === 'SECCION'" class="w-full mb-2 bg-gray-200 border-l-4 border-gray-500 p-2 rounded shadow-sm">
                  <label class="block uppercase tracking-wider text-gray-800 text-sm font-bold text-left">
                    <template v-if="one_question.numero_pregunta">{{ one_question.numero_pregunta }}.- </template>{{ one_question.texto }}
                    <template v-if="one_question.nota_para_registrante">
                      ({{ one_question.nota_para_registrante }})
                    </template>
                  </label>
                </div>
                <div v-else-if="one_question.texto != null">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    ><template v-if="one_question.numero_pregunta">{{ one_question.numero_pregunta }}.- </template>{{ one_question.texto }}</label
                  >

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO ABIERTAS -->
                  <div v-if="one_question.tipo === 'ABIERTA'">
                    <textarea-styled
                      v-if="one_question.tipo === 'ABIERTA'"
                      class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      name="question"
                      :value="one_question.respuesta"
                      disabled
                      :colorT="color_terciario"
                    />
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO ABIERTAS -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO MULTISELECCION -->
                  <div v-else-if="one_question.tipo === 'MULTISELECCION'">
                    <template
                      v-for="(id_key, answer) in one_question.respuesta
                        .opciones"
                    >
                      <input-styled
                        v-if="id_key === true"
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="answer"
                        disabled
                        :colorT="color_terciario"
                      />
                    </template>

                    <div
                      v-if="
                        one_question.respuesta.otro != null &&
                        one_question.respuesta.otro != ''
                      "
                      class="flex items-left text-gray-700 font-bold"
                      style="align-items: baseline"
                    >
                      Otro: &nbsp; &nbsp;
                      <input-styled
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="one_question.respuesta.otro"
                        disabled
                        :colorT="color_terciario"
                      />
                    </div>

                    <template
                      v-if="
                        one_question.respuesta.hasOwnProperty('subpregunta')
                      "
                    >
                      <template
                        v-for="(answer, index) in one_question.respuesta
                          .subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          ><span v-if="answer.numero_pregunta">{{ answer.numero_pregunta }}.- </span>{{ answer.texto }}</label
                        >

                        <template v-if="answer.tipo == 'SELECCION'">
                          <template
                            v-if="answer.respuesta.selected_answer != 'Otro'"
                          >
                            <input-styled
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="answer.respuesta.selected_answer"
                              disabled
                              :colorT="color_terciario"
                            />
                          </template>

                          <template v-else>
                            <input-styled
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="
                                answer.respuesta.selected_answer +
                                ': ' +
                                answer.respuesta.otro
                              "
                              disabled
                              :colorT="color_terciario"
                            />
                          </template>
                        </template>

                        <template v-if="answer.tipo == 'ABIERTA'">
                          <textarea-styled
                            class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer.respuesta"
                            disabled
                            :colorT="color_terciario"
                          />
                        </template>

                        <template v-if="answer.tipo == 'CAMPOS'">
                          <template v-for="(id_key, label) in answer.respuesta">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ label }}</label
                              >
                              <input-styled
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="id_key"
                                disabled
                                :colorT="color_terciario"
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO MULTISELECCION -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO SELECCION_CONDICIONAL -->
                  <div
                    v-else-if="one_question.tipo === 'SELECCION_CONDICIONAL'"
                  >
                    <input-styled
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      name="question"
                      :value="one_question.respuesta.selected_answer"
                      disabled
                      :colorT="color_terciario"
                    />

                    <template
                      v-if="
                        one_question.respuesta.conditional_answer.hasOwnProperty(
                          one_question.respuesta.selected_answer
                        )
                      "
                    >
                      <label
                        class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                        >{{
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].id
                        }}.-
                        {{
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].texto
                        }}</label
                      >

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'ABIERTA'
                        "
                      >
                        <textarea-styled
                          class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta
                          "
                          disabled
                          :colorT="color_terciario"
                        />

                        <template
                          v-if="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].hasOwnProperty('subpregunta')
                          "
                        >
                          <template
                            v-for="(opt, index) in one_question.respuesta
                              .conditional_answer[
                              one_question.respuesta.selected_answer
                            ].subpregunta"
                          >
                            <label
                              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                            >
                              <span v-if="opt.numero_pregunta">{{ opt.numero_pregunta }}.-</span>
                              {{ opt.texto }}
                            </label>

                            <template v-if="opt.tipo == 'SELECCION'">
                              <input-styled
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="opt.respuesta"
                                disabled
                                :colorT="color_terciario"
                              />
                            </template>
                          </template>
                        </template>
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'MULTISELECCION'
                        "
                      >
                        <template
                          v-for="(id_key, answer) in one_question.respuesta
                            .conditional_answer[
                            one_question.respuesta.selected_answer
                          ].respuesta.opciones"
                        >
                          <input-styled
                            v-if="id_key === true"
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer"
                            disabled
                            :colorT="color_terciario"
                          />
                        </template>

                        <template
                          v-if="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta.otro != ''
                          "
                        >
                          <input-styled
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="
                              'Otro:' +
                              ' ' +
                              one_question.respuesta.conditional_answer[
                                one_question.respuesta.selected_answer
                              ].respuesta.otro
                            "
                            disabled
                            :colorT="color_terciario"
                          />
                        </template>
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'SELECCION'
                        "
                      >
                        <input-styled
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta
                          "
                          disabled
                          :colorT="color_terciario"
                        />
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo === 'CAMPOS'
                        "
                      >
                        <template
                          v-for="(id_key, answer) in one_question.respuesta
                            .conditional_answer[
                            one_question.respuesta.selected_answer
                          ].respuesta"
                        >
                          <div class="flex w-full items-center justify-center">
                            <label
                              class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ answer }}</label
                            >
                            <input-styled
                              class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="id_key"
                              disabled
                              :colorT="color_terciario"
                            />
                          </div>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO SELECCION_CONDICIONAL -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO SELECCION -->
                  <div v-else-if="one_question.tipo === 'SELECCION'">
                    <template
                      v-if="one_question.respuesta.selected_answer != 'Otro'"
                    >
                      <input-styled
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="one_question.respuesta.selected_answer"
                        disabled
                        :colorT="color_terciario"
                      />
                    </template>
                    <template v-else>
                      <input-styled
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="
                          one_question.respuesta.selected_answer +
                          ': ' +
                          one_question.respuesta.otro
                        "
                        disabled
                        :colorT="color_terciario"
                      />
                    </template>

                    <template
                      v-if="
                        one_question.respuesta.hasOwnProperty('subpregunta')
                      "
                    >
                      <template
                        v-for="(answer, index) in one_question.respuesta
                          .subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          ><span v-if="answer.numero_pregunta">{{ answer.numero_pregunta }}.- </span>{{ answer.texto }}</label
                        >

                        <template v-if="answer.tipo == 'SELECCION'">
                          <template
                            v-if="answer.respuesta.selected_answer != 'Otro'"
                          >
                            <input-styled
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="answer.respuesta.selected_answer"
                              disabled
                              :colorT="color_terciario"
                            />
                          </template>

                          <template v-else>
                            <input-styled
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="
                                answer.respuesta.selected_answer +
                                ' ' +
                                answer.respuesta.otro
                              "
                              disabled
                              :colorT="color_terciario"
                            />
                          </template>
                        </template>

                        <template v-if="answer.tipo == 'ABIERTA'">
                          <textarea-styled
                            class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer.respuesta"
                            disabled
                            :colorT="color_terciario"
                          />
                        </template>

                        <template v-if="answer.tipo == 'CAMPOS'">
                          <template v-for="(id_key, label) in answer.respuesta">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ label }}</label
                              >
                              <input-styled
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="id_key"
                                disabled
                                :colorT="color_terciario"
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO SELECCION -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO CAMPOS -->
                  <div v-else-if="one_question.tipo === 'CAMPOS' || one_question.tipo === 'MINI_FORMULARIO'">
                    <template
                      v-for="(id_key, answer) in one_question.respuesta"
                    >
                      <div class="flex w-full items-center justify-center">
                        <label
                          class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ answer }}</label
                        >
                        <input-styled
                          class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="id_key"
                          disabled
                          :colorT="color_terciario"
                        />
                      </div>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO CAMPOS -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO GRUPO_REPETIBLE -->
                  <div v-else-if="one_question.tipo === 'GRUPO_REPETIBLE'">
                    <div v-for="(group, groupIndex) in one_question.respuesta" :key="'group_' + groupIndex" class="mb-4 p-4 border border-gray-300 rounded bg-gray-50">
                      <div class="font-bold text-gray-600 mb-2 text-sm">Registro {{ groupIndex + 1 }}</div>
                      <template v-for="(val, label) in group">
                        <div class="flex w-full items-center justify-center">
                          <label class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left">{{ label }}</label>
                          <input-styled
                            class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            :value="Array.isArray(val) ? val.join(', ') : val"
                            disabled
                            :colorT="color_terciario"
                          />
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO GRUPO_REPETIBLE -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO OPCION_SEGUIMIENTO -->
                  <div v-else-if="one_question.tipo === 'OPCION_SEGUIMIENTO'">
                    <div v-for="(ans, idx) in one_question.respuesta" :key="'ans_' + idx" class="mb-4">
                      <p class="font-bold text-gray-700 text-sm mb-2">{{ ans.concepto }}</p>
                      <div class="flex w-full items-center justify-center">
                        <label class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left">Respuesta</label>
                        <input-styled
                          class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          :value="ans.selected_answer"
                          disabled
                          :colorT="color_terciario"
                        />
                      </div>
                      <div v-if="ans.sub_respuesta && ans.sub_respuesta !== '' && !(Array.isArray(ans.sub_respuesta) && ans.sub_respuesta.length === 0)">
                        <div class="flex w-full items-center justify-center">
                          <label class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left">Detalle</label>
                          <input-styled
                            class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            :value="Array.isArray(ans.sub_respuesta) ? ans.sub_respuesta.join(', ') : ans.sub_respuesta"
                            disabled
                            :colorT="color_terciario"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO OPCION_SEGUIMIENTO -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO MATRIZ -->
                  <template v-else-if="one_question.tipo === 'MATRIZ'">
                      <div class="overflow-x-auto mb-3 pl-4">
                        <table class="w-full text-left border-collapse">
                          <thead>
                            <tr v-if="one_question.columnas && one_question.columnas.length">
                              <th class="border-b-2 p-2"></th>
                              <th
                                v-for="(col, colIdx) in one_question.columnas"
                                :key="'col' + colIdx"
                                class="border-b-2 p-2 text-sm text-gray-700 font-bold text-center"
                              >
                                {{ col }}
                              </th>
                            </tr>
                            <tr v-else>
                              <th class="border-b-2 p-2 text-sm text-gray-700 font-bold"></th>
                              <th class="border-b-2 p-2 text-sm text-gray-700 font-bold text-center">Respuesta</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-if="one_question.columnas && one_question.columnas.length">
                              <tr
                                v-for="(fila, filaIdx) in (one_question.filas || [])"
                                :key="'fila_' + filaIdx"
                              >
                                <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                  {{ fila }}
                                </td>
                                <td
                                  v-for="(col, colIdx) in one_question.columnas"
                                  :key="'cell' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input
                                    type="radio"
                                    disabled
                                    :checked="getMatrixAnswer(one_question.respuesta, fila, col)"
                                    class="leading-tight"
                                  />
                                </td>
                              </tr>
                              <tr v-if="(one_question.respuesta && (one_question.respuesta.otro_texto || one_question.respuesta.otro_respuesta))">
                                <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                  {{ (one_question.respuesta && one_question.respuesta.otro_texto) || 'Otro' }}
                                </td>
                                <td
                                  v-for="(col, colIdx) in one_question.columnas"
                                  :key="'cell_otro_' + colIdx"
                                  class="border-b p-2 text-center"
                                >
                                  <input
                                    type="radio"
                                    disabled
                                    :checked="one_question.respuesta && (one_question.respuesta.otro_respuesta === col || getMatrixAnswer(one_question.respuesta, 'otro', col))"
                                    class="leading-tight"
                                  />
                                </td>
                              </tr>
                            </template>
                            <template v-else>
                              <tr
                                v-for="(fila, filaIdx) in Object.keys(one_question.respuesta || {})"
                                :key="'fila_fallback_' + filaIdx"
                              >
                                <td class="border-b p-2 text-sm text-gray-700 font-bold">
                                  {{ fila }}
                                </td>
                                <td class="border-b p-2 text-sm text-gray-700 text-center">
                                  {{ one_question.respuesta[fila] || '-' }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                  </template>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO MATRIZ -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO FECHA -->
                  <div v-else-if="one_question.tipo === 'FECHA'">
                    <div class="w-1/2 lg:w-2/3 px-3 mb-6 md:mb-0">
                      <input-styled
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="date"
                        name="question"
                        :value="one_question.respuesta"
                        disabled
                        :colorT="color_terciario"
                      />
                    </div>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO FECHA -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO FOTO -->
                  <div v-else-if="one_question.tipo === 'FOTO'">
                    <div v-if="one_question.respuesta" class="w-full px-3 mb-6 md:mb-0">
                      <div v-if="Array.isArray(one_question.respuesta)" class="flex flex-wrap gap-2 mt-2">
                        <img
                          v-for="(img, imgIdx) in one_question.respuesta"
                          :key="'foto_' + imgIdx"
                          :src="img"
                          class="w-36 h-36 object-cover rounded border border-gray-300 shadow-sm cursor-pointer hover:opacity-90 transition"
                          @click="openFullPictureModal(img)"
                        />
                      </div>
                      <div v-else>
                        <img :src="one_question.respuesta" class="w-48 h-48 object-cover rounded mt-2 border border-gray-300 cursor-pointer" @click="openFullPictureModal(one_question.respuesta)" />
                      </div>
                    </div>
                    <div v-else class="text-sm italic text-gray-500 mt-2 px-3">
                      Sin imagen adjunta.
                    </div>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO FOTO -->

                  <div v-else>Ninguna de las anteriores</div>
                </div>
              </div>
              <!-- /Ficha de información-->
            </div>
          </div>
        </div>
        <div v-if="category != 'ADMINISTRADOR'">
          <btn-action
            v-if="
              currentRaising.status === 'NO REVISADO' ||
              (currentRaising.status === 'EN REVISIÓN' &&
                email === currentRaising.email_curador)
            "
            v-on:click="updateStatusModal('APROBADO', 'APROBAR')"
            class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
            :colorT="color_terciario"
          >
            APROBAR
          </btn-action>
          <btn-action
            v-if="
              currentRaising.status === 'NO REVISADO' ||
              (currentRaising.status === 'EN REVISIÓN' &&
                email === currentRaising.email_curador)
            "
            v-on:click="updateStatusModal('RECHAZADO', 'RECHAZAR')"
            class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
            :colorT="color_terciario"
          >
            RECHAZAR
          </btn-action>
          <btn-action
            v-if="
              currentRaising.status === 'NO REVISADO' ||
              (currentRaising.status === 'EN REVISIÓN' &&
                email === currentRaising.email_curador)
            "
            v-on:click="newChatModal()"
            class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
            :colorT="color_terciario"
          >
            MENSAJES
          </btn-action>
          <!--             <button 
              v-if = "currentRaising.status === 'NO REVISADO' || (currentRaising.status === 'EN REVISIÓN' && email === currentRaising.email_curador)"
              v-on:click="updateQuestionsModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >EDITAR</button> -->
          <!-- <button
              v-if = "currentRaising.status === 'NO REVISADO' || (currentRaising.status === 'EN REVISIÓN' && email === currentRaising.email_curador)"
              v-on:click="updateStatusModal('EN REVISIÓN','DEVOLVER')"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >DEVOLVER</button>  -->
        </div>

        <div v-if="category == 'ADMINISTRADOR'">
          <btn-action
            v-on:click="newChatModal()"
            class="bg-transparent font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border hover:border-transparent rounded"
            :colorT="color_terciario"
          >
            VER MENSAJES
          </btn-action>
        </div>
      </div>
    </div>

    <raising-modal
      :showing="showRaisingModal"
      @close="showRaisingModal = false"
      @updateAllRaising="fetchRaising"
    ></raising-modal>

    <raising-chat-modal
      :showing="showCommentsModal"
      @close="closeChatModal"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></raising-chat-modal>

    <project-detail-modal
      :showing="showProjectDetail"
      @close="showProjectDetail = false"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></project-detail-modal>

    <user-raising-update-questions-modal
      :showing="showUpdateQuestionsModal"
      @close="closeUpdateQuestionsModal()"
      @updateQuestions="updateQuestions()"
      :colorP="color_principal"
      :colorS="color_secundario"
      :colorT="color_terciario"
    ></user-raising-update-questions-modal>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <div
      v-if="showFullPicture"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="flex flex-wrap max-h-full bg-white shadow-lg rounded-lg w-9/12 px-5 pb-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0 z-50 bg-white pt-5">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="showFullPicture = false"
          >
            ×
          </button>
        </div>
        <div class="w-full px-4 py-2 h-full flex items-center justify-center">
          <img :src="pictureModalSrc" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import urlMixin from "@/mixins/urlMixin";
import moment from "moment";

import AlertDialog from "./AlertDialog";

/* import polygon from "../assets/polygonChapp.json";
 */
import L from "leaflet";

import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import { Icon } from "leaflet";
import EventBus from "../event-bus";

import RaisingModal from "./RaisingModal";

import RaisingChatModal from "./RaisingChatModal";

import ProjectDetailModal from "./ProjectDetailModal.vue";

import UserRaisingUpdateQuestionsModal from "./UserRaisingUpdateQuestionsModal";

import tokml from "tokml";

import shpwrite from "shp-write";


import { styled } from "@egoist/vue-emotion";

const BtnAction = styled("button")`
  color: ${(props) => props.colorT};
  border-color: ${(props) => props.colorT};
  &.bg-selected {
    background-color: ${(props) => props.colorT};
    color: #fff;
  }
  &:hover {
    background-color: ${(props) => props.colorT};
  }
`;

const DivSelectedStyled = styled("div")`
  &.bg-selected {
    background-color: ${(props) => props.colorT};
  }
  &:hover {
    background-color: #d1d5db;
  }
`;

const TextareaStyled = styled("textarea")`
  border-color: ${(props) => props.colorT};
  resize: none;
`;

const InputStyled = styled("input")`
  border-color: ${(props) => props.colorT};
`;

export default {
  mixins: [urlMixin],
  name: "raising-list",
  data() {
    return {
      categories: null,
      raising: [],
      currentRaising: {},
      currentQuestions: [],
      list_path_media_folder: [],
      search: "",
      raisingOrder: "downward",
      statusFilterRaising: "NO REVISADOS",
      email: localStorage.getItem("email"),
      category: window.atob(localStorage.getItem("category")),
      showUpdateQuestionsModal: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      showingError: false,
      /* polygon: polygon, */
      zoom: 12,
      center: [20.58651, -89.01501],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false,
      },
      chatRaising: null,
      chartList: null,
      showChatModal: false,
      showRaisingModal: false,
      showCommentsModal: false,
      showProjectDetail: false,
      showingDisaproveConfirm: false,
      showingSuccessDisaprove: false,
      showingDeleteConfirm: false,
      showingSuccessDelete: false,
      categoryFilter: "-1",
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
      showFullPicture: false,
      pictureModalSrc: "",
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LTileLayer,
    AlertDialog,
    RaisingModal,
    RaisingChatModal,
    ProjectDetailModal,
    UserRaisingUpdateQuestionsModal,
    BtnAction,
    DivSelectedStyled,
    TextareaStyled,
    InputStyled,
  },
  watch: {
    showFullPicture(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.name) {
      this.statusFilterRaising = "TODOS";
      let id = this.$route.query.id.toString();
      let name = this.$route.query.name.toString();
      this.search = `${id} ${name}`;
    }

    EventBus.$emit("updateNotification", {});
    this.fetchRaising();
    this.fetchCategories();
  },
  methods: {
    onMapReady: function () {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        //esri.basemapLayer("Topographic").addTo(map);
      });
    },

    updateSelectRegister() {
      if (this.filteredRaising.length > 0) {
        this.selectRaising(this.filteredRaising[0]);
      }
    },

    fetchCategories() {
      this.categories = [];
      this.axios
        .post(
          "apidev/levantamientos/getProjectLevantamiento",
          {
            email: this.email,
            category: this.category,
          },
          this.config
        )
        .then((response) => {
          //this.categories = response.data;
          response.data.proyectos.forEach((element) => {
            if (
              element.nombre_proyecto != "Patrimonio material" &&
              element.nombre_proyecto != "Patrimonio inmaterial"
            ) {
              this.categories.push(element);
            }
          });
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },

    fetchRaising() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "apidev/levantamientos/getLevantamientosGeneral",
          {
            email: this.email,
            category: this.category,
          },
          this.config
        )
        .then((response) => {
          this.raising = response.data.levantamientos;
          this.$root.$emit("hideLoading");
          if (this.filteredRaising.length > 0) {
            this.selectRaising(this.filteredRaising[0]);
          }
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    updateQuestions() {
      this.selectRaising(this.currentRaising);
    },
    closeUpdateQuestionsModal() {
      this.showUpdateQuestionsModal = false;
    },
    selectRaising(raising) {
      this.$root.$emit("showLoading");
      this.list_path_media_folder = [];
      this.currentRaising = raising;
      // removed console log

      if (raising.latitud !== null && raising.longitud !== null) {
        this.center = [raising.latitud, raising.longitud];
        this.showMarker = true;
      } else {
        this.showMarker = false;
      }

      /* this.axios
        .post(
          "../apidev/levantamientos/media/list",
          {
            id: this.currentRaising.id,
          },
          this.config
        )
        .then((response) => {
          // removed console log
          this.list_path_media_folder = JSON.parse(
            response.data.list.path_media_folder
          );
          return this.axios.post(
            "../apidev/levantamientos/getFichaRespuestasJson",
            {
              id_levantamiento: this.currentRaising.id,
            },
            this.config
          );
        })
        .then((response) => {
          this.currentQuestions = response.data.answers;
          // removed console log
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        }); */
      this.axios
        .post(
          "../apidev/levantamientos/getFichaRespuestasJson",
          {
            id_levantamiento: this.currentRaising.id,
          },
          this.config
        )
        .then((response) => {
          let allAnswers = response.data.answers || [];
          let tiempos = allAnswers.find(a => a.total !== undefined && a.secciones !== undefined);
          if (tiempos) {
            this.$set(this.currentRaising, 'tiempos_encuesta', tiempos);
            this.currentQuestions = allAnswers.filter(a => a !== tiempos);
          } else {
            this.$set(this.currentRaising, 'tiempos_encuesta', null);
            this.currentQuestions = allAnswers;
          }
          // removed console log
          this.list_path_media_folder = JSON.parse(
            this.currentRaising.path_media_folder
          );
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;

          this.list_path_media_folder = JSON.parse(
            this.currentRaising.path_media_folder
          );

          this.$root.$emit("hideLoading");
        });
    },

    changeRaisingOrder() {
      this.raisingOrder =
        this.raisingOrder === "upward" ? "downward" : "upward";
    },

    updateStatusModal(status, label) {
      this.showRaisingModal = true;
      EventBus.$emit("statusModal", {
        raising_id: this.currentRaising.id,
        status: status,
        label: label,
        menu: "LEVANTAMIENTO",
      });
    },

    newChatModal() {
      this.showCommentsModal = true;
      let showNewMessageButton = true;
      let is_curador = true;
      if (this.category == "ADMINISTRADOR") {
        showNewMessageButton = false;
        is_curador = false;
      }
      EventBus.$emit("showChatModal", {
        raising_id: parseInt(this.currentRaising.id),
        userficha_id: this.currentRaising.usuario_id,
        is_curador: is_curador,
        showNewMessageButton: showNewMessageButton,
        menu: "LEVANTAMIENTO",
      });
    },
    closeChatModal() {
      this.showCommentsModal = false;
      //this.fetchRaising();
    },
    joinCategories(opciones) {
      let string_categories = "";
      for (const property in opciones) {
        if (opciones[property]) {
          string_categories += property + ", ";
        }
      }

      return string_categories;
    },

    showProjectDetailModal() {
      this.showProjectDetail = true;
      EventBus.$emit("showProjectDetail", {
        id_proyecto: this.currentRaising.id_proyecto,
      });
    },

    desaprobarFicha() {
      // removed console log
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/levantamientos/desaprobarLevantamiento/" +
            this.currentRaising.id,
          {
            user_id: localStorage.getItem("user_id"),
            activo: "false",
          },
          this.config
        )
        .then((response) => {
          // removed console log

          this.showingDisaproveConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingSuccessDisaprove = true;

          //guarda bitácora
          let name = localStorage.getItem("name");
          let user_id = localStorage.getItem("user_id");

          //// removed console log

          this.axios
            .post(
              "/apidev/bitacoras/save/",
              {
                module: "Revisión de aportes",
                action: "Ficha desaprobada",
                observation:
                  name +
                  " desaprobó la ficha con folio F-" +
                  this.currentRaising.id +
                  " (" +
                  this.currentRaising.title +
                  ")",
                email: localStorage.getItem("email"),
                user_id: localStorage.getItem("user_id"),
              },
              this.config
            )
            .then((response) => {
              //// removed console log
            })
            .catch((error) => {
              // removed console log
            });
          //FIN guarda bitácora

          this.fetchRaising();
          //// removed console log
          //// removed console log
          /*           if(response["data"]["status"] == "Proyecto eliminado"){
            this.currentRaising = {};
            this.fetchProjects();
            this.search = "";
            this.showingDisaproveConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessDelete = true;            
          }
          if(response["data"]["status"] == "El proyecto tiene aportes asociados"){
            this.showingDisaproveConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingProjectNotEmpty = true;            
          }   */
          /*           this.currentRaising = {};
          this.fetchProjects();
          this.search = "";
          this.showingDeactivationConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingSuccessDeactivation = true; */
        })
        .catch((error) => {
          //this.catchError(error);
          // removed console log
          this.showingDisaproveConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },

    eliminarFicha() {
      // removed console log

      this.$root.$emit("showLoading");
      this.axios
        .delete(
          "../apidev/levantamientos/deleteLevantamiento/" +
            this.currentRaising.id,
          {
            user_id: localStorage.getItem("user_id"),
            activo: "false",
          },
          this.config
        )
        .then((response) => {
          // removed console log

          this.showingDeleteConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingSuccessDelete = true;

          //guarda bitácora
          let name = localStorage.getItem("name");
          let user_id = localStorage.getItem("user_id");

          //// removed console log

          this.axios
            .post(
              "/apidev/bitacoras/save/",
              {
                module: "Revisión de aportes",
                action: "Ficha eliminada",
                observation:
                  name +
                  " eliminó la ficha con folio F-" +
                  this.currentRaising.id +
                  " (" +
                  this.currentRaising.title +
                  ")",
                email: localStorage.getItem("email"),
                user_id: localStorage.getItem("user_id"),
              },
              this.config
            )
            .then((response) => {
              //// removed console log
            })
            .catch((error) => {
              // removed console log
            });
          //FIN guarda bitácora

          this.fetchRaising();
        })
        .catch((error) => {
          //this.catchError(error);
          // removed console log
          this.showingDeleteConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },


    updateQuestionsModal() {
      this.showUpdateQuestionsModal = true;
      EventBus.$emit("updateQuestionsModal", {
        id: parseInt(this.currentRaising.id),
        id_project: this.currentRaising.id_proyecto,
        id_cat_principal: parseInt(this.currentRaising.id_cat_principal),
        curret_questions: this.currentQuestions,
        editQuestion: true,
      });
    },
    closeUpdateQuestionsModal() {
      this.showUpdateQuestionsModal = false;
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
    toGeojsonFile() {
      // removed console log
      let geojsonObject = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [
            this.currentRaising.longitud,
            this.currentRaising.latitud,
          ],
        },
        properties: {},
      };

      let geojsonProperties = {};
      geojsonProperties["proyecto"] = this.currentRaising.nombre;
      geojsonProperties["descripción"] = this.currentRaising.descripcion;
      geojsonProperties["institucion"] = this.currentRaising.institucion;
      geojsonProperties["fecha"] = new Date(this.currentRaising.fecha_creacion);

      this.currentRaising.geometria.properties = geojsonProperties;

      var convertedData =
        "text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(geojsonObject)); //encodeURIComponent recibe el geojson como texto
      document
        .getElementById("downGeojson")
        .setAttribute("href", "data:" + convertedData);
      document
        .getElementById("downGeojson")
        .setAttribute("download", this.currentRaising.nombre + ".geojson");
    },
    toKMLFile() {
      // removed console log
      // removed console log
      let geojsonObject = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [
            this.currentRaising.longitud,
            this.currentRaising.latitud,
          ],
        },
        properties: {},
      };

      var kml = tokml(geojsonObject); //tokml recibe el geojson como objecto
      var convertedData =
        "application/xml;charset=utf-8," + encodeURIComponent(kml);

      // if you want to use the official MIME type for KML
      // var convertedData = 'application/vnd.google-earth.kml+xml;charset=utf-8,'+
      // encodeURIComponent(kml);

      document
        .getElementById("downKML")
        .setAttribute("href", "data:" + convertedData);
      document
        .getElementById("downKML")
        .setAttribute("download", this.currentRaising.nombre + ".kml");
    },
    toSHPFile() {
      // removed console log
      let geojsonObject = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [
            this.currentRaising.longitud,
            this.currentRaising.latitud,
          ],
        },
        properties: {},
      };

      var options = {
        folder: this.currentRaising.nombre,
        types: {
          point: "puntos",
          polygon: "polígonos",
          line: "líneas",
        },
      };

      let info = {
        type: "FeatureCollection",
        features: [geojsonObject],
      };
      // a GeoJSON bridge for features
      shpwrite.download(info, options); //shpwrite recibe el geojson como objeto
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then((response) => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    openFullPictureModal(imgSrc) {
      this.pictureModalSrc = imgSrc.replace("_resize", "");
      this.showFullPicture = true;
    },
    getMatrixAnswer(respuesta, fila, col) {
      if (!respuesta) return false;
      let resObj = respuesta;
      if (typeof respuesta === 'string') {
        try {
          resObj = JSON.parse(respuesta);
        } catch (e) {
          return false;
        }
      }
      if (!resObj) return false;
      let ans = resObj[fila];
      if (ans === col) return true;
      if (Array.isArray(ans) && ans.includes(col)) return true;
      return false;
    },
  },
  computed: {
    nestedStatusFicha() {
      let inSection = false;
      if (!this.currentQuestions) return [];
      return this.currentQuestions.map(q => {
        if (q.tipo === 'SECCION') {
          inSection = true;
          return false;
        }
        return inSection;
      });
    },
    filteredRaising() {
      return this.raising
        .filter((elem) => {
          let date = moment(elem.fecha_levantamiento).format("DD/MM/YYYY");

          let new_string_search = `${date.toLowerCase()} ${elem.id.toString()} ${elem.titulo.toLowerCase()}`;
          switch (this.statusFilterRaising) {
            case "TODOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                (this.categoryFilter === "-1" ||
                  elem.nombre_proyecto === this.categoryFilter)
              );
            case "RECHAZADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "RECHAZADO" &&
                (this.categoryFilter === "-1" ||
                  elem.nombre_proyecto === this.categoryFilter)
              );
            case "NO REVISADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "NO REVISADO" &&
                (this.categoryFilter === "-1" ||
                  elem.nombre_proyecto === this.categoryFilter)
              );
            case "EN REVISIÓN":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "EN REVISIÓN" &&
                (this.categoryFilter === "-1" ||
                  elem.nombre_proyecto === this.categoryFilter)
              );
            case "APROBADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "APROBADO" &&
                (this.categoryFilter === "-1" ||
                  elem.nombre_proyecto === this.categoryFilter)
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.raisingOrder === "upward") {
            return (
              new Date(a.fecha_levantamiento) - new Date(b.fecha_levantamiento)
            );
          } else {
            return (
              new Date(b.fecha_levantamiento) - new Date(a.fecha_levantamiento)
            );
          }
        });
    },
    filteredRaisingByAll() {
      return this.raising.filter(
        (elem) =>
          this.categoryFilter === "-1" ||
          elem.nombre_proyecto === this.categoryFilter
      );
    },
    filteredRaisingByOpen() {
      return this.raising.filter(
        (elem) =>
          elem.status == "NO REVISADO" &&
          (this.categoryFilter === "-1" ||
            elem.nombre_proyecto === this.categoryFilter)
      );
    },
    filteredRaisingByAssigned() {
      return this.raising.filter(
        (elem) =>
          elem.status == "EN REVISIÓN" &&
          (this.categoryFilter === "-1" ||
            elem.nombre_proyecto === this.categoryFilter)
      );
    },
    filteredRaisingByCanceled() {
      return this.raising.filter(
        (elem) =>
          elem.status == "RECHAZADO" &&
          (this.categoryFilter === "-1" ||
            elem.nombre_proyecto === this.categoryFilter)
      );
    },
    filteredRaisingByAttended() {
      return this.raising.filter(
        (elem) =>
          elem.status == "APROBADO" &&
          (this.categoryFilter === "-1" ||
            elem.nombre_proyecto === this.categoryFilter)
      );
    },

    //NO REVISADO, EN REVISION, APROBADO, RECHAZADO
  },
  beforeMount() {
    this.fetchConfiguration();
  },
};
</script>

<style scoped>
textarea {
  resize: none;
}

.textareaficha {
  resize: vertical;
  text-align: justify;
  height: auto;
}

.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
